const STORAGE_KEY = 'tenantAdminLoginRemember'

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { lastTenantCode: '', accounts: {} }
    const parsed = JSON.parse(raw)
    return {
      lastTenantCode: String(parsed?.lastTenantCode || '').trim(),
      accounts: parsed?.accounts && typeof parsed.accounts === 'object' ? parsed.accounts : {},
    }
  } catch {
    return { lastTenantCode: '', accounts: {} }
  }
}

function writeStore(store) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
}

function accountKey(tenantCode) {
  return String(tenantCode || '').trim().toLowerCase()
}

/** 登录成功后保存该租户的账号密码（按租户码分仓） */
export function saveTenantLoginRemember({ tenantCode, username, password }) {
  const code = String(tenantCode || '').trim()
  if (!code) return

  const store = readStore()
  const key = accountKey(code)
  store.lastTenantCode = code
  store.accounts[key] = {
    username: String(username || ''),
    password: String(password || ''),
  }
  writeStore(store)

  // 兼容旧字段，便于其他逻辑读取用户名
  localStorage.setItem('adminLoginUsername', String(username || ''))
}

/** 读取指定租户（或最近一次租户）的账号密码 */
export function getTenantLoginRemember(tenantCode) {
  const store = readStore()
  const code = String(tenantCode || store.lastTenantCode || '').trim()
  if (!code) {
    return {
      tenantCode: '',
      username: localStorage.getItem('adminLoginUsername') || '',
      password: '',
    }
  }

  const saved = store.accounts[accountKey(code)]
  if (saved) {
    return {
      tenantCode: code,
      username: saved.username || '',
      password: saved.password || '',
    }
  }

  return {
    tenantCode: code,
    username: '',
    password: '',
  }
}

/** 登录页初始租户码：优先最近一次成功登录的租户 */
export function getRememberedTenantCode() {
  const remembered = getTenantLoginRemember('').tenantCode
  if (remembered) return remembered
  const legacy = (localStorage.getItem('tenantAdmin:tenantCode') || localStorage.getItem('tenantCode') || '').trim()
  if (!legacy || legacy.toLowerCase() === 'platform') return ''
  return legacy
}
